import { createSelector } from '@reduxjs/toolkit';
import { AppState } from 'store';
import { KontentDeliveryTaxonomyDTO } from 'utils/restApplicationClient';
import { IContentPagination, IContentState, IFilterFieldsData } from './content.interface';

export const getContentSelector = createSelector(
  ({ content }: AppState) => content,
  (content): IContentState => content,
);

export const getContentPaginationSelector = createSelector(
  ({ content }: AppState) => content.pagination,
  (pagination): IContentPagination => pagination,
);

export const getFilterFieldsDataSelector = createSelector(
  ({ content: { workflowSteps, contentTypes } }: AppState) => ({
    workflowSteps,
    contentTypes,
  }),
  (filterFieldsData): IFilterFieldsData => filterFieldsData,
);

export const getContentTaxonomiesSelector = createSelector(
  ({ content }: AppState) => content.taxonomies,
  (taxonomies): Array<KontentDeliveryTaxonomyDTO> => taxonomies,
);
